module.exports = __webpack_public_path__ + "static/media/KidneyOutline.0bf99bc4.png";